import { render } from "./ModalEditRole.vue?vue&type=template&id=2cebbd30&scoped=true"
import script from "./ModalEditRole.vue?vue&type=script&lang=js"
export * from "./ModalEditRole.vue?vue&type=script&lang=js"

import "./ModalEditRole.vue?vue&type=style&index=0&id=2cebbd30&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cebbd30"]])

export default __exports__